import { render, staticRenderFns } from "./accountDetails.vue?vue&type=template&id=78906784&scoped=true"
import script from "./accountDetails.vue?vue&type=script&lang=js"
export * from "./accountDetails.vue?vue&type=script&lang=js"
import style0 from "./accountDetails.vue?vue&type=style&index=0&id=78906784&scoped=true&lang=css"
import style1 from "./accountDetails.vue?vue&type=style&index=1&id=78906784&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78906784",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('78906784')) {
      api.createRecord('78906784', component.options)
    } else {
      api.reload('78906784', component.options)
    }
    module.hot.accept("./accountDetails.vue?vue&type=template&id=78906784&scoped=true", function () {
      api.rerender('78906784', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/finance/basicData/customerAccount/cmp/accountDetails.vue"
export default component.exports